<template>
  <div class="login">
    <div class="login_bgd">
      <img src="../../assets/visitor/login_bgd.png" alt="" />
    </div>
    <div class="login_form">
      <div class="login_form_left">
        <img src="../../assets/visitor/login_left.png" alt="" />
      </div>
      <div class="login_form_right">
        <img src="../../assets/visitor/login_right_top.png" alt="" />
        <div class="right_title">欢迎使用雷士访客管理系统</div>
        <el-input v-model="username" placeholder="请输入账号"></el-input>
        <el-input
          v-model="password"
          placeholder="请输密码"
          type="password"
        ></el-input>
        <div class="checked_content">
          <el-checkbox v-model="checked">记住密码</el-checkbox>
        </div>

        <el-button type="primary" @click="login">登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis";
// import utils from '@/utils/utils'
export default {
  data() {
    return {
      username: "",
      password: "",
      // username: '18501633638',
      // password: '18501633638',
      checked: false
    };
  },
  mounted() {
    const userPassword = JSON.parse(localStorage.getItem("userPassword"));
    console.log("userPassword", userPassword.username);
    if (userPassword.username && userPassword.password) {
      this.username = userPassword.username;
      this.password = userPassword.password;
      this.checked = true;
    } else {
      this.checked = false;
    }
  },
  methods: {
    // 登录
    login() {
      if (this.checked) {
        localStorage.setItem(
          "userPassword",
          JSON.stringify({
            username: this.username,
            password: this.password
          })
        );
      } else {
        localStorage.setItem(
          "userPassword",
          JSON.stringify({
            username: "",
            password: ""
          })
        );
      }

      api
        .login({
          username: this.username,
          password: this.password
        })
        .then(res => {
          if (res.code == 200) {
            sessionStorage.setItem("visitorUserName", JSON.stringify(res.data));
            sessionStorage.setItem("usernamePad", res.data.username);

            this.queryRole(this.username);
          }
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: "error"
          });
        });
    },
    //获取角色权限
    queryRole(username) {
      api.queryRoleApi({ username }).then(res => {
        if (res.code == 200) {
          this.dataType = res.data.map(item => item.dataType);
          console.log(this.dataType);
          if (this.dataType.includes(1) || this.dataType.includes(2)) {
           
            this.$router.replace({
              // path: "/pad/visitor"
              path: "/pad/dormManage"
            });
          } else {
            this.$router.replace({
              // path: "/pad/visitor"
              path: "/pad/carRelease"
            });
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login {
  position: relative;
  width: 100vw;
  height: 100vh;
  background: #f0f0f0;
  overflow: hidden;
  .login_bgd {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .login_form {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    width: 700px;
    height: 440px;
    background: #ffffff;
    box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.1);
    .login_form_left {
      width: 50%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .login_form_right {
      width: 50%;
      img {
        display: block;
        width: 42px;
        height: 42px;
        margin: 54px auto 22px;
      }
      .right_title {
        height: 28px;
        font-size: 20px;
        font-family: PingFang-SC-Bold, PingFang-SC;
        font-weight: bold;
        color: #2b2b2b;
        line-height: 28px;
        text-align: center;
      }
      .checked_content {
        ::v-deep {
          .el-checkbox {
            display: block;
            width: 270px;
            margin: 24px auto;
          }
          .el-checkbox__inner {
            width: 16px;
            height: 16px;
          }
          .el-checkbox__inner::after {
            width: 5px;
            height: 9px;
            left: 5px;
            top: 1px;
          }
        }
      }

      ::v-deep .el-input {
        display: block;
        width: 270px;
        height: 40px;
        background: #f5f5f7;
        margin: 24px auto;
        border-radius: 6px;
        .el-input__inner {
          width: 100%;
          height: 100%;
          background: #f5f5f7;
          border: none;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          // color: #A6ADC4;
          color: #333;
          line-height: 19px;
        }
      }
      ::v-deep .el-button--primary {
        display: block;
        width: 270px;
        height: 40px;
        margin: 0 auto;
        background: #338f6c;
        border-color: #338f6c;
        border-radius: 6px;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: #ffffff;
        line-height: 21px;
      }
    }
  }
}
</style>
